

<script>
    export let icon;
    export let css = "text-black";
</script>


<span class="material-icons {css}">{icon}</span>